export default "__VITE_ASSET__sTIHdhJT__"